module.exports = __webpack_public_path__ + "school/img/chunwan.5e32632c.jpg";